export default "__VITE_ASSET__a8DdmnMs__"